import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.css";
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";
import parser from "html-react-parser";

export default function Body({ loanOfficerData }) {
  const imgCDNURL = process.env.REACT_APP_RENOVATION_PROGRAM_CDN_URL;
  const loanOfficerName = loanOfficerData ? capitalizeFirstLetter(loanOfficerData.name) : "";

  let mobilePhoneNumberFormatted,
    mobilePhoneNumberWithInternationalCode,
    mobilePhoneNumberInTitle,
    workPhoneNumberFormatted,
    workPhoneNumberWithInternationalCode,
    workPhoneNumberInTitle;

  try {
    mobilePhoneNumberFormatted = loanOfficerData ? formatPhoneNumber(
      loanOfficerData.mobilePhoneNumber
    ) : "";
    mobilePhoneNumberWithInternationalCode = loanOfficerData ? addInternationalCode(
      loanOfficerData.mobilePhoneNumber,
      "+1"
    ) : "";
    mobilePhoneNumberInTitle = "Contact me at " + mobilePhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get loan officer's mobile phone number.", error);
  }

  try {
    workPhoneNumberFormatted = loanOfficerData ? formatPhoneNumber(loanOfficerData.workPhoneNumber) : "";
    workPhoneNumberWithInternationalCode = loanOfficerData ? addInternationalCode(
      loanOfficerData.workPhoneNumber,
      "+1"
    ) : "";
    workPhoneNumberInTitle = "Contact me at " + workPhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get loan officer's work phone number.", error);
  }

  return (
    <>
      <div className="loaninfodata">
        <Container>
          {loanOfficerData ? (
            <Row className="">
              <Col sm={12} md={12} xl={12} lg={12} className='loanofficer-col'>
                <div className="lo-img-bg">
                  <div className="lo-img-background">
                  <img
                    src={loanOfficerData.profileImage}
                    className="lo-img"
                    alt={loanOfficerName}
                  />
                  </div>
                  <div className='lo-text'>
                    <p className="namejoaqu">{loanOfficerName}</p>
                    <p className="namejo2">
                      {loanOfficerData.nmls ? (
                        <>
                          NMLS {loanOfficerData.nmls}
                          <br></br>
                        </>
                      ) : (
                        ""
                      )}
                      {loanOfficerData.designation ? (
                        <>
                          {loanOfficerData.designation}
                          <br></br>
                        </>
                      ) : (
                        ""
                      )}
                      {loanOfficerData.mobilePhoneNumber ? (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={"tel:" + mobilePhoneNumberWithInternationalCode}
                            title={mobilePhoneNumberInTitle}
                            aria-label={mobilePhoneNumberInTitle}
                          >
                            {mobilePhoneNumberFormatted}
                          </a>
                          <br></br>
                        </>
                      ) : (
                        ""
                      )}
                      {/* {loanOfficerData.workPhoneNumber ? (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={"tel:" + workPhoneNumberWithInternationalCode}
                            title={workPhoneNumberInTitle}
                            aria-label={workPhoneNumberInTitle}
                          >
                            D: {workPhoneNumberFormatted}
                          </a>
                          <br></br>
                        </>
                      ) : (
                        ""
                      )} */}
                      {loanOfficerData.emailAddress ? (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={"mailto:" + loanOfficerData.emailAddress}
                            title={"Email me at " + loanOfficerData.emailAddress}
                            aria-label={"Email me at " + loanOfficerData.emailAddress}
                          >
                            {loanOfficerData.emailAddress}
                          </a>
                          <br></br>
                        </>
                      ) : (
                        ""
                      )}
                      {loanOfficerData.userWebsite ? (
                          <>
                            <a
                              style={{ textDecoration: "none" }}
                              href={loanOfficerData.userWebsite.startsWith("http") ? loanOfficerData.userWebsite : `http://${loanOfficerData.userWebsite}`}
                              target="_blank"
                            >
                              {loanOfficerData.userWebsite.replace(/^https?:\/\//, "")}
                            </a>
                            <br></br>
                          </>
                        ) : (
                          ""
                        )}
                      {loanOfficerData.streetAddress ? (
                        <>
                          {loanOfficerData.streetAddress}<br></br> {loanOfficerData.city}, {loanOfficerData.state} {loanOfficerData.zipCode}
                        </>
                      ) : (
                        ""
                      )}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Container>
      </div>
      <div id="gettrueapproveScroll"></div>
    </>
  );
}
